import { render, staticRenderFns } from "./ServiceDashboardTutorManagerCard.vue?vue&type=template&id=7529f0db&"
import script from "./ServiceDashboardTutorManagerCard.vue?vue&type=script&lang=js&"
export * from "./ServiceDashboardTutorManagerCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports